<template>
  <div class="product-status-wrapper" v-if="showStatus">
    <div class="status" :class="cssClasses">
      <!-- <i class="material-icons">{{ isInStock ? 'check' : 'close' }}</i> -->
      <!-- <cms-block-chunk :identifier="`c_${chunkMap[1](isInStock)}`" /> -->
      <p class="available" v-if="isInStock">{{ $t('available') }}</p>
      <p class="unavailable" v-else>{{ $t('unavailable') }}</p>
    </div>
  </div>
</template>

<script>
import CmsBlockChunk from 'theme/components/core/blocks/Cms/BlockChunk';

export default {
  props: {
    product: {
      type: Object,
      required: true
    }
  },

  components: {
    CmsBlockChunk
  },

  computed: {
    cssClasses () {
      return {
        'status--available': this.isInStock
      };
    },

    isInStock () {
      const { stock } = this.product;
      return stock[0].is_in_stock && stock[0].qty > 0;
    },

    showStatus () {
      const { chunkMap, isInStock, product } = this
      return (product.custom_2 in chunkMap && chunkMap[product.custom_2](isInStock)) || !(product.custom_2 in chunkMap)
    }
  },

  data: () => ({
    chunkMap: {
      0: (isInStock) => 'MAGAZYN_BRAK_1',
      1: (isInStock) => isInStock ? 'MAGAZYN_DOSTEPNY_LISTA' : 'MAGAZYN_BRAK_LISTA',
      2: (isInStock) => isInStock ? 'MAGAZYN_DOSTEPNY_LISTA' : 'NA_ZAMOWIENIE_LISTA',
      3: (isInStock) => isInStock ? 'MAGAZYN_DOSTEPNY_LISTA' : null,
      4: (isInStock) => isInStock ? 'MAGAZYN_DOSTEPNY_LISTA' : 'MAGAZYN_BRAK_LISTA',
      5: (isInStock) => isInStock ? 'MAGAZYN_DOSTEPNY_LISTA' : 'NA_ZAMOWIENIE_LISTA',
      6: (isInStock) => isInStock ? 'MAGAZYN_DOSTEPNY_LISTA' : null,
      7: (isInStock) => isInStock ? 'MAGAZYN_DOSTEPNY_LISTA' : 'MAGAZYN_BRAK_LISTA',
      8: (isInStock) => isInStock ? 'MAGAZYN_DOSTEPNY_LISTA' : 'NA_ZAMOWIENIE_LISTA',
      9: (isInStock) => isInStock ? 'MAGAZYN_DOSTEPNY_LISTA' : null,
      10: (isInStock) => isInStock ? 'MAGAZYN_DOSTEPNY_LISTA' : 'NA_ZAMOWIENIE_LISTA',
      11: (isInStock) => isInStock ? 'MAGAZYN_DOSTEPNY_LISTA_11' : 'MAGAZYN_BRAK_LISTA_11',
      12: (isInStock) => isInStock ? 'MAGAZYN_DOSTEPNY_LISTA_12' : 'MAGAZYN_BRAK_LISTA_12'
    }
  })
};
</script>

<style lang="scss" scoped>
  @import '~theme/css/variables/colors';
  @import '~theme/css/helpers/functions/color';
  $color-strong-cyan: color(strong-cyan);
  $color-gainsboro: color(gainsboro);
  $color-dark-blue: color(dark-blue);

  .product-status-wrapper {
    margin-top: 0px;
    text-align: center;

    .available {
      color: $green;
      margin-top: 0;
    }
    .unavailable {
      margin-top: 0;
      color: $color-dark-blue;
    }
  }

  .status {
    display: inline-block;
    padding: 3px 10px;
    border-radius: 3px;
    font-size: 14px;
    color: $color-dark-blue;

    &--available {
      border-color: $color-strong-cyan;
      color: $color-strong-cyan;
    }

    .material-icons {
      font-size: 1em;
      position: relative;
      top: 2px;
    }
  }
</style>
<style lang="scss">
  .product-status-wrapper {
    .status {
      > div {
        display: inline-block;

       p {
         margin: 0;
        }
     }
    }
  }
</style>
